<template>
  <div id="metrics-planning-b2b">
        <v-row v-if="metricsInformation !== null">
            <v-col cols="12" sm="4" md="4" lg="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.budget-hours1')}}</span> <i id="budgetedHours1" @mouseleave="showBudgetedHours1 = false" @mouseover="showBudgetedHours1 = true" class="b-fa b-fa-info-circle"></i>
                </v-col>
                <v-col cols="12" class="box-metric d-flex flex-column align-items-center">
                    <span>{{metricsInformation.budgetedHours1}}</span>
                    <p style="margin-bottom: 0px">{{$t('planning.metrics-component.budget-hours1-complement')}} {{metricsInformation.budgetedHours2}}</p>
                </v-col>
                <v-card v-show="showBudgetedHours1" class="card-info">
                    <p>{{$t('planning.metrics-component.budget-hours1')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.budget-hours1-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.free-hours')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showFreeHours = false" @mouseover="showFreeHours = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span>{{metricsInformation.freeHours}}</span>
                </v-col>
                <v-card v-show="showFreeHours" class="card-info">
                    <p>{{$t('planning.metrics-component.free-hours')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.free-hours-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.work-hours')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showWorkHours = false" @mouseover="showWorkHours = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span>{{metricsInformation.workHours}}</span>
                </v-col>
                <v-card v-show="showWorkHours" class="card-info">
                    <p>{{$t('planning.metrics-component.work-hours')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.work-hours-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.productivity')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showProductivity = false" @mouseover="showProductivity = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric-graphic">
                    <v-chart
                        v-if="graphicIsReady"
                        style="width: auto; height: 100px"
                        ref="chart_ref_efficiency"
                        :options="optionGraphic"
                        manualUpdate
                    />
                </v-col>
                <v-card v-show="showProductivity" class="card-info">
                    <p>{{$t('planning.metrics-component.productivity')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.productivity-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.efficiency')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showEfficiency = false" @mouseover="showEfficiency = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span style="font-weight: bold;" :style="efficiencyColor(metricsInformation.efficiency)">{{metricsInformation.efficiency}}%</span>
                </v-col>
                <v-card v-show="showEfficiency" class="card-info">
                    <p>{{$t('planning.metrics-component.efficiency')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.efficiency-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.budgeted-amount')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showBudgetedAmount = false" @mouseover="showBudgetedAmount = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span>{{metricsInformation.budgetedAmount}}</span>
                </v-col>
                <v-card v-show="showBudgetedAmount" class="card-info">
                    <p>{{$t('planning.metrics-component.budgeted-amount')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.budgeted-amount-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
            </v-col>
        </v-row>

        <v-row v-else>
          <v-col cols="12" sm="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.budget-hours1')}}</span> <i id="budgetedHours1" @mouseleave="showBudgetedHours1 = false" @mouseover="showBudgetedHours1 = true" class="b-fa b-fa-info-circle"></i>
                </v-col>
                <v-col cols="12" class="box-metric d-flex flex-column align-items-center">
                    <span>0h</span>
                    <p style="margin-bottom: 0px">{{$t('planning.metrics-component.budget-hours1-complement')}} 0h</p>
                </v-col>
                <v-card v-show="showBudgetedHours1" class="card-info">
                    <p>{{$t('planning.metrics-component.budget-hours1')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.budget-hours1-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
          </v-col>
          <v-col cols="12" sm="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.free-hours')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showFreeHours = false" @mouseover="showFreeHours = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span>0h</span>
                </v-col>
                <v-card v-show="showFreeHours" class="card-info">
                    <p>{{$t('planning.metrics-component.free-hours')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.free-hours-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
          </v-col>
          <v-col cols="12" sm="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.work-hours')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showWorkHours = false" @mouseover="showWorkHours = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span>0h</span>
                </v-col>
                <v-card v-show="showWorkHours" class="card-info">
                    <p>{{$t('planning.metrics-component.work-hours')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.work-hours-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
          </v-col>
          <v-col cols="12" sm="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.productivity')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showProductivity = false" @mouseover="showProductivity = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric-graphic">
                    <v-chart
                        v-if="graphicIsReady"
                        style="width: auto; height: 100px"
                        ref="chart_ref_efficiency"
                        :options="optionGraphic"
                        manualUpdate
                    />
                </v-col>
                <v-card v-show="showProductivity" class="card-info">
                    <p>{{$t('planning.metrics-component.productivity')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.productivity-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
          </v-col>
          <v-col cols="12" sm="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.efficiency')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showEfficiency = false" @mouseover="showEfficiency = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span style="font-weight: bold;" :style="efficiencyColor(0)">0%</span>
                </v-col>
                <v-card v-show="showEfficiency" class="card-info">
                    <p>{{$t('planning.metrics-component.efficiency')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.efficiency-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
          </v-col>
          <v-col cols="12" sm="2" class="box-container">
                <v-col cols="12" class="metric-title">
                    <span>{{$t('planning.metrics-component.budgeted-amount')}}</span> <i class="b-fa b-fa-info-circle" @mouseleave="showBudgetedAmount = false" @mouseover="showBudgetedAmount = true"></i>
                </v-col>
                <v-col cols="12" class="box-metric">
                    <span>0,00€</span>
                </v-col>
                <v-card v-show="showBudgetedAmount" class="card-info">
                    <p>{{$t('planning.metrics-component.budgeted-amount')}}</p>
                    <div class="table-tooltip-info-metrics">
                        <table>
                            <tr>
                                <td class="subinfo-info-tooltip-metrics">{{$t('planning.metrics-component.budgeted-amount-tooltip')}}</td>
                            </tr>
                        </table>
                    </div>
                </v-card>
          </v-col>
      </v-row>
  </div>
</template>

<script>
export default {

    /** @param propsExample
        metricsInformation = {
            budgetedAmount: "0,00€",
            budgetedHours1: "0h",
            budgetedHours2: "9h",
            efficiency: 123,
            freeHours: "9h",
            productivity: "0%",
            workHours: "0h",
        }
     */

    props: {
        metricsInformation: Object
    },

    watch: {
        metricsInformation: {
            handler: function(newValue, oldValue) {
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                if(newValue) {
                    this.optionGraphic.series[0].data[0].value = newValue.productivity;
                    if(oldValue) {
                        if (newValue?.productivity !== oldValue?.productivity) {
                            this.graphicIsReady = false;
                            setTimeout(() => {
                                this.graphicIsReady = true;
                            }, 50)
                        }
                    }
                }
                this.$store.commit('loadings/setStateLoadingTemplate', false);
            },
            deep: true,
            immediate: true,
        }
    },

    data() {
        return {
            optionGraphic: {
                series: [
                    {
                        type: 'gauge',
                        splitNumber: 5,
                        axisLine: {
                            lineStyle: {
                            width: 10,
                                color: [
                                    [0.3, '#F40000'],
                                    [0.7, '#FFE017'],
                                    [1, '#2CAA2A']
                                ]
                            }
                        },
                        pointer: {
                            length: '20px',
                            width: 2,
                            itemStyle: {
                                color: '#4B4849'
                            }
                        },
                        axisTick: {
                            distance: -30,
                            length: 0,
                            lineStyle: {
                                color: '#fff',
                                width: 2
                            }
                        },
                        splitLine: {
                            distance: 5,
                            length: 0,
                            lineStyle: {
                                color: '#fff',
                                width: 4
                            }
                        },
                        axisLabel: {
                            show: true,
                            color: '#4B4849',
                            distance: -12,
                            fontSize: 10
                        },
                        detail: {
                            valueAnimation: true,
                            formatter: '{value}%',
                            color: '#4B4849',
                            fontSize: 14,
                        },
                        data: [
                            {
                                value: this.metricsInformation?.productivity ? this.metricsInformation.productivity : 0
                            }
                        ]
                    }
                ]
            },
            showBudgetedHours1: false,
            showFreeHours: false,
            showBudgetedAmount: false,
            showEfficiency: false,
            showProductivity: false,
            showWorkHours: false,
            graphicIsReady: true,
        }
    },

    methods: {
        efficiencyColor(value) {
            if(value <= 30)
                return "color: #F40000";
            else if (value > 30 && value <= 79)
                return "color: #FFE017";
            else if(value >= 80)
                return "color: #2CAA2A"
            else
                return "color: #4b4849"
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@sass/_variables.scss';
#metrics-planning-b2b {

    .box-container {
        position: relative;
    }

    .metric-title {
        background-color: var(--v-primary-base);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        text-align: center;
        padding: 3px;
        span {
            color: white;
            font-size: 12px;
            text-transform: uppercase;
        }
        i {
            color: white;
            cursor: pointer;
        }
    }

    .box-metric {
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 2px solid #4B4849;
        height: 100px;
        span {
            color: #4B4849;
            letter-spacing: 0px;
            font-size: 30px;
        }

        p {
            color: #4B4849;
            letter-spacing: 0px;
            font-size: 12px;
        }
    }

    .box-metric-graphic {
        position: relative;
        border-bottom: 2px solid #4B4849;
        height: 100px;
        padding: 0;
    }

    .card-info {
        position: absolute;
        top: 50px;
        right: 0px;
        bottom: auto;
        width: 200px;
        z-index: 999;

        p {
            background-color: #D6D6D6;
            text-align: center;
            font-size: 14px;
            border-bottom: 1px solid #D6D6D6;
            color: #4B4849;
            padding: 5px;
        }

        .table-tooltip-info-metrics {
            margin-bottom: 16px;
            table {
                .subinfo-info-tooltip-metrics {
                    font-size: 12px;
                    letter-spacing: 0px;
                    color: #4B4849;
                    opacity: 1;
                    padding-left: 10px;
                    padding-right: 5px;
                }
            }
        }
    }

}
</style>
